import { IPersonaProps } from '@fluentui/react';
import { aCampusMembers } from 'features/Rooms/RoomView/atom';
import { useCallback, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { idpService } from 'services/api/identity-provider.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useCampusMembersManager = () => {
    const [members, setMembers] = useRecoilState<IPersonaProps[]>(aCampusMembers);

    const convertMemberToPersona = (member: any): IPersonaProps => {
        const { userId, profile_pic, name } = member;

        const personaDetails = {
            id: userId,
            primaryText: name,
            imageUrl: profile_pic
        };
        return personaDetails;
    };
    const fetchMembersList = useCallback(async (): Promise<void> => {
        const fetchedMembers = await idpService.showMembers();
        const memberPersona: IPersonaProps[] = [];
        if (fetchedMembers) {
            fetchedMembers.forEach((member) => memberPersona.push(convertMemberToPersona(member)));
            setMembers(memberPersona);
        }
    }, []);

    useEffect(() => {
        fetchMembersList();
    }, []);

    return [members];
};

export default useCampusMembersManager;
